import { render, staticRenderFns } from "./activityTabsDetails.vue?vue&type=template&id=1f1c2c33"
import script from "./activityTabsDetails.vue?vue&type=script&lang=js"
export * from "./activityTabsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports